import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import {
  bookAppointment,
  checkSchedule,
  getEncounterRecord,
  getSlots,
  updateAppointmentRequest,
  getlistPractitioners
} from "../api/AppointmentRequests";
import { failed, success } from "../../common/Toastify";
import { useFormik } from "formik";
import moment from "moment";
import { useSelector } from "react-redux";
import { generatePass } from "../AppointmentRequests/Constants";
import { getSignature } from "../../Zoom/functions";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { LOCATIONS } from "../../common/location";
import { editQuestionnaireResponse } from "../../api/Questionnaire";
import { getSingleUser } from "../../api/Individual";
import { decryptData } from "../../EncryptDecrypt";
import { CircularProgress, Skeleton } from "@mui/material";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { Button } from "../../common/Button";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import { Form } from "react-bootstrap";
import { getScheduleSlots } from "../../api/Schedule";
import { on } from "ws";
import { getOrganization } from "../../api/Organization";
import { axios } from "../../../lib/axios";
import { createQuestionnaireResponse } from "../../api/Questionnaire";
import { buildSessionTopic } from "../../../utils/ZoomSessionSupport";
import { validation, conditionalValidation } from "../../../utils/constants";

const ScheduleAppointmentWR = ({
  onShow,
  onHide,
  encounterId,
  questionnaireData,
  patientName,
  patientId,
  type = "patient",
  questionnaireResponseId,
}) => {
  const [encounterData, setEncounterData] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [practitionerList, setPractitionerList] = useState([]);
  const user = useSelector((state) => state?.auth?.user);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [availableDays, setAvailableDays] = useState([]);
  const [slotUnavailable, setSlotUnavailable] = useState(false);
  const [practitionerId, setPractitionerId] = useState( "" );
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [categoriesByDay, setCategoriesByDay] = useState({});
  const [reservedCategories, setReservedCategories] = useState({});
  const practitionerUniqueId = useSelector( (state) => state?.auth?.user?.["custom:unique_id"]);
  const userOrg = useSelector((state) => state?.auth?.user?.organizations)
  const userOrgId = userOrg?.[0]?.id;
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [Questions, setQuestions] = useState([]);
  const [fetchedSchedules, setFetchedSchedules] = useState([]);
  const [computedServiceCategories, setComputedServiceCategories] = useState([]);

  const sortedObj = data => {
    return data.sort((a,b) => {
        return a.name > b.name ? 1 : -1
    });
  }

  /***
     * merge is used to merge 2 objects.  Previously used Object.assign and it would
     * cause data lose, so this is a better method for the categories by day which
     * modifies the obj1 with data from obj2.
     */
  const merge = (obj1, obj2) => {
    for(let key in obj2) {
        if(obj1[key]) {
            // if both elements contain an array, then extend the array
            if(Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                obj2[key].forEach(cat => {
                    if(!obj1[key].includes[cat])
                        obj1[key].push(cat);
                })
            }
            else {
                // else replace the value with matching obj2
                obj1[key] = obj2[key]
            }
        }
        else 
            obj1[key] = obj2[key];
    }
    return obj1;
}

  useEffect(() => {
    getEncounterRecord({ encounterId: encounterId })
      .then((res) => {
        if (res?.status === true) {
          setEncounterData(res?.data);
        }
      })
      .catch((res) =>
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        )
      );
      getOrganization(adminOrgs?.[0]?.id)
      .then(async (res) => { 
        if (res.data?.assignedQuestionnaire?.["telephone-intake"]) {
          const response = await axios.get(
            `questionnaire/${res.data?.assignedQuestionnaire?.["telephone-intake"]}`
          );
          formik.setFieldValue("questionnaireId", response?.data?.id);
          setQuestions(
            response?.data?.item?.map((item) => ({
              ...item,
              name: item?.text,
              value: item?.id,
            }))
          ); 
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });
  }, []);

  useEffect(() => {
          if(encounterData?.patientLocation){
            let scope = encounterData.patientLocation
            getlistPractitioners({orgId: user?.organizations[0]?.id , scopeOfPractice: scope })
              .then(async (res) => {
                let allPracts = res.result?.filter(pra => pra.active);
                let activePractitioners = [];
                let startDate = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
                startDate = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
                
                await checkSchedule({actorId: user["custom:unique_id"], date: startDate, orgId: user?.organizations[0]?.id })
                .then((activeSchedules)=> {
                    if(!activeSchedules?.data) { 
                        // no active schedules, so list no practitioners
                        failed(activeSchedules?.message);
                        setServiceCategory([]);
                        setCategoriesByDay({});
                        setPractitionerList([]);
                        return;
                    }
                    if(!Array.isArray(activeSchedules.data)) 
                        activeSchedules.data = [activeSchedules.data];
    
                    // remove empty schedules
                    activeSchedules.data = activeSchedules.data.filter(sch => {
                        return sch.orgId === user?.organizations[0]?.id 
                            && sch.serviceCategory?.length > 0 
                            && sch.serviceCategory.filter(cat => moment(cat.date).isSameOrAfter(moment(startDate), "day")).length > 0
                    })
                    
                    activeSchedules.data.forEach(schedule => {
                        let active = allPracts.find(person => person.id === schedule.actorId && !activePractitioners.some(exists => exists.id === schedule.actorId))
                        if(active) 
                            activePractitioners.push(active);
                    })
                    // practitioners that have active schedules for the current month.
                    setPractitionerList(activePractitioners.map(ele => (
                        { 
                            value: ele?.id, 
                            name: ele?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), // capitalize all names, surname, given name, etc.
                            id: ele?.id 
                        }
                    ))) 
                })                
                .catch((activeSchedules) => {
                    failed(activeSchedules?.response?.data?.message || activeSchedules?.response?.data?.error || activeSchedules.message);
                    setServiceCategory([]);
                    setCategoriesByDay({});
                    setPractitionerList([]);
                });            
              })
              .catch((res) => {
                console.log("error fetching practioner list",res)
              })}
        }, [encounterData]);

  const formik = useFormik({
    initialValues: {
      title: "",
      patient: "",
      date: "",
      serviceCategory: "",
      availableSlot: "",
      preferredChannel: "",
      returnTelephoneNumber: "",
      returnTelephoneNumberExt: "",
      practitionerPreference: "",
      practitioner: "",
    },
    validationSchema: Yup.object({
      title: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Reason for Visit",
          mandatory: true
        }),
      patient: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Patient",
          mandatory: true
        }),
      date: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Date",
          mandatory: true
        }),
      serviceCategory: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Appointment Type",
          mandatory: true
        }),
      availableSlot: Yup.object().required("Required slots field."),
      preferredChannel: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Preferred Channel",
          mandatory: true
        }),
      returnTelephoneNumber: conditionalValidation(
        Yup.string()
          .matches(
            /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
            "Enter Valid Return Telephone Number."
          ),
          {
            validation,
            label: "Return Telephone Number",
            mandatory: true
          }),
      returnTelephoneNumberExt: conditionalValidation(
        Yup.string().matches(/^\d{0,4}$/, "Must be 4 digit or less."),
        {
          validation,
          label: "Extension"
        }),
      practitionerPreference: conditionalValidation(
        type === "patient"
          ? Yup.string().required("Required Practitioner Preference field.")
          : null,
          {
            validation
          }),
      practitioner:
        type === "patient"
          ? Yup.mixed().when(["practitionerPreference"], {
              is: (practitionerPreference) =>
                practitionerPreference !== "no preference",
              then: Yup.string().required("Required Practitioner field."),
              otherwise: Yup.mixed().notRequired(),
            })
          : null,
    }),
    onSubmit: async (values) => {
      values.title = values.title?.trim();
      setBtnLoading(true);
      try {
        let slot = null;
        let utcStart = values?.availableSlot?.start;
        let utcEnd = values?.availableSlot?.end;
        let selectedServiceCategory = values?.serviceCategory;
    
        selectedServiceCategory = serviceCategory?.filter(
          (categoryData) => categoryData.value === selectedServiceCategory
        )?.[0];
    
        if (selectedServiceCategory?.value?.endsWith("busyReserved")) {
          selectedServiceCategory = structuredClone(selectedServiceCategory);
          selectedServiceCategory.id = selectedServiceCategory?.value?.split("-")[0];
          selectedServiceCategory.name = selectedServiceCategory.name.substring(12).trim();
        }
    
        const serviceCategoryPayload = [
          {
            coding: [
              {
                system: "http://florizel.com/AppointmentServiceCategory",
                code: selectedServiceCategory?.id,
                display:
                  selectedServiceCategory?.display || selectedServiceCategory?.name,
              },
            ],
            text: `Appointment for ${
              selectedServiceCategory?.display || selectedServiceCategory?.name
            }`,
          },
        ];
    
        if (formik?.values?.practitionerPreference === "no preference") {
          values.practitioner = values?.availableSlot?.actorId;
          values.scheduleId = values?.availableSlot?.scheduleId;
        } else {
          values.scheduleId = values?.availableSlot?.scheduleId;
        }
    
        values.orgId = userOrgId;
        const requestedPeriod = [{ start: utcStart, end: utcEnd }];
        const topic = user?.name[0]?.text.trim();
        const password = generatePass();
    
        const signatureResponse = await getSignature({
          topic,
          role: 0,
          password,
        });
        const sessionToken = signatureResponse?.data?.sessionToken;

        
    
        //const questionResponse = Questions.map((item) => ({
        //  id: item.linkId,
        //  questionId: item?.id || null,
        //  question: item.text,
        //  answer: item.answerOption.map((option) => ({
        //    id: option.id,
        //    questionId: item?.id || null,
        //    required: item.required,
        //    answer: "",
        //    option: item.answerType === "radio" ? option.text : null,
        //   value: item.answerType === "dropDown" ? option.text : null,
        //    name: item.answerType === "dropDown" ? option.text : null,
        //  })),
        //  questionType: item.answerType,
        //  required: item.required,
        //}));
    
        // Set specific answers
        //questionResponse[0].answer[0].answer = patientName.replace(/\b\w/g, (c) =>
        //  c.toUpperCase()
        //);
        //questionResponse[1].answer[0].answer = values?.returnTelephoneNumber;
        //questionResponse[2].answer[0].answer =
        //  questionnaireData?.callerRelationship === "Self";
        //questionResponse[4].answer[0].answer = questionnaireData?.consent === "Yes";
        //questionResponse[6].answer[0].answer = values?.title;
        //questionResponse[5].answer[0].answer =
        //  Object.keys(LOCATIONS).find(
        //    (key) => LOCATIONS[key] === encounterData?.patientLocation
        //  ) || "";
    
        //const questionnaireResponseRes = await createQuestionnaireResponse({
        //  patientID: patientId,
        //  encounterId: "",
        //  questionResponse,
        //  appointmentId: "",
        //  questionnaire: values.questionnaireId,
        //  authorName: user?.name[0]?.text,
        //  authorType: "Practitioner",
        //  authorId: user["custom:practitioner_id"],
        //});
    
        //const questionnaireResponseId = questionnaireResponseRes.data.id;
        
    
        let intakeQuestions = {};
        if (type === "patient") {
          intakeQuestions = {
            //questionnaireResponseId: {
            //  reference: `QuestionnaireResponse/${questionnaireResponseId}`,
            //},
            preferredChannel: values?.preferredChannel,
            callerName: patientName.replace(/\b\w/g, (c) => c.toUpperCase()),
            callerNumber: values?.returnTelephoneNumber,
            callerNumberExt: values?.returnTelephoneNumberExt,
            callerRelationship: questionnaireData?.callerRelationship,
            reason: values?.title,
            location: encounterData?.patientLocation || "",
          };
        }
    
        const bookAppointmentRes = await bookAppointment({
          serviceCategory: serviceCategoryPayload,
          slot,
          sessionToken,
          requestType:
            formik?.values?.practitionerPreference === "no preference"
              ? "organization"
              : "provider",
          practitionerId: values?.practitioner || practitionerUniqueId,
          patientId,
          requestedPeriod,
          description: values?.title,
          intakeQuestions,
          patientLocation: intakeQuestions.location,
          scheduleId: values?.scheduleId,
        });
    
        if (type === "patient") {
          const updatePayload = {
            isHostJoined: false,
            sessionToken,
            id: bookAppointmentRes?.result?.id,
            status: "booked",
            patientId: bookAppointmentRes?.result?.patientId,
            practitionerId: bookAppointmentRes?.result?.practitionerId,
            proceedWith: questionnaireData?.howToProcced || "SCHEDULE",
            intakeQuestions,
            patientLocation: intakeQuestions.location,
          };
    
          await updateAppointmentRequest(updatePayload);
          //await editQuestionnaireResponse(questionnaireResponseId, {
          //  encounterId: bookAppointmentRes?.result?.encounterId,
          //  authorName: user?.name[0]?.text,
          //  authorType: "Practitioner",
          //  authorId: user["custom:practitioner_id"],
          //});
    
          onHide();
          success("Appointment Scheduled");
        }
      } catch (error) {
        failed(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error.message
        );
      } finally {
        setBtnLoading(false);
      }
    },
  });
  useEffect(() => {
    if (questionnaireData) {
      const phoneNumber = questionnaireData?.callerNumber || "";
      const match = phoneNumber.match(/ext\s*(\d+)/i);
      const extension = match ? match[1] : questionnaireData?.callerNumberExt || "";
      const numberWithoutExt = match ? phoneNumber.replace(/ext\s*\d+/i, "").trim() : phoneNumber;
  
      formik.setFieldValue("title", questionnaireData?.intakeReason || "");
      formik.setFieldValue("returnTelephoneNumber", numberWithoutExt);
      formik.setFieldValue("returnTelephoneNumberExt", extension);
      formik.setFieldValue("patient", patientName || "");
    }
  }, []);

  /**
     * Loads available slots for a given date and appointment type.
     * Handles reserved slots, merges with available slots, and sorts them.
     */
  const loadSlotData = (selectedDate, selectedType) => {
    setSlotsLoading(true);
    setSlotUnavailable(false);

    const today = moment();
    const date = moment(selectedDate || formik?.values?.date);
    const type = selectedType || formik?.values?.serviceCategory;
    const dateUtc = date.utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";

    if (!type) {
        setSlotsLoading(false);
        return;
    }

    // Get reserved slots for this type
    let reservedSlots = reservedCategories[type] || [];
    reservedSlots = reservedSlots
        .filter(slot => moment(slot.start).isAfter(date) && moment(slot.start).isSame(date, "day"));
    reservedSlots = sortedSlots(reservedSlots);

    // Prepare params for fetching available slots
    const params = {
        actorId: practitionerId || user["custom:unique_id"],
        date: dateUtc,
        serviceCategoryId: type,
        orgId: formik?.values?.practitionerPreference === "no preference"
            ? user?.organizations[0]?.id
            : userOrgId
    };

    // Add scopeOfPractice if needed
    if (formik?.values?.practitionerPreference === "no preference") {
      params.scopeOfPractice = encounterData.patientLocation
    }

    getSlots(params)
        .then(res => {
            let available = res?.data?.availableSlots || [];
            // Remove past/late slots
            if (date.isSame(today, "day")) {
                available = removeLateSlots(removePastSlots(available), dateUtc);
            } else {
                available = removeLateSlots(removeSlotsOutsideOfDayRange(available, date.utc()), date.utc());
            }
            available = sortedSlots(available);

            // Merge reserved slots, avoiding duplicates
            reservedSlots.forEach(slot => {
                if (!available.some(item => item.start === slot.start)) {
                    available.push(slot);
                }
            });

            available = sortedSlots(available);
            setAvailableSlots(available);

            if (available.length < 1) {
                setSlotUnavailable(true);
            }
        })
        .catch(err => {
            if (reservedSlots.length > 0) {
                setAvailableSlots(reservedSlots);
            } else {
                failed(err?.response?.data?.message || err?.response?.data?.error || err?.message);
                setAvailableSlots([]);
            }
        })
        .finally(() => setSlotsLoading(false));
};

const removeLateSlots = (slots, date) => {
  let midnight = (date) ? new Date(date) : new Date();
  // console.log("DATE", midnight) // date before processing
  midnight = new Date(midnight.setDate(midnight.getDate()+1));
  midnight.setHours(0)
  midnight.setMinutes(0)
  midnight.setSeconds(0);
  // console.log("REMOVE LATE SLOTS MIDNIGHT: ", midnight); // midnight of submitted date.
  if(Array.isArray(slots)) {
      // console.log("slot count", slots.length)
      const filteredSlots = slots.filter(slot => {
          // console.log("SLOT END", slot.end)
          let endTime = new Date(slot.end).getTime();
          let midnightTime = midnight.getTime();
          console.log(endTime < midnightTime, slot.start)
          return (endTime < midnightTime)
      })
      console.log("slot count after filter", filteredSlots.length)
      //setOrgSlotsData(filteredSlots);
      return filteredSlots;
  }
  else return slots;        
}

function removeSlotsOutsideOfDayRange(slots, date) {
  let midnight = (date) ? new Date(date) : new Date();
  midnight = new Date(midnight.setDate(midnight.getDate()));
  midnight.setHours(0)
  midnight.setMinutes(0)
  midnight.setSeconds(0);
  // console.log("REMOVE OUTSIDE DAY RANGE MIDNIGHT: ", midnight); // start of submitted day, localtime.
  if(Array.isArray(slots)) {
      // console.log("slot count", slots.length)
      const filteredSlots = slots.filter(slot => {
          // console.log("SLOT START", slot.start)
          let startTime = new Date(slot.start).getTime();
          let midnightTime = midnight.getTime();
          // console.log(startTime > midnightTime, slot.start)
          return (startTime > midnightTime)
      })
      // console.log("slot count after filter", filteredSlots.length)
      //setOrgSlotsData(filteredSlots);
      return filteredSlots;
  }
  else return slots;
}

  const handleDateSelection = (val) => {
    const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
    setAvailableSlots([])
    if(type === "patient"){
        if(formik.values.practitionerPreference == ''){
            failed('Please select practitioner preference')
        }else{
            if(isValidDate){
                formik.setFieldValue("date", val.format("YYYY-MM-DD"));
                // load slots here
                loadSlotData(val.format("YYYY-MM-DD"))
            }else{
                formik.setFieldError('date', 'Invalid date format')
            }
        }
    }else{
        if(isValidDate){
            formik.setFieldValue("date", val.format("YYYY-MM-DD"));
            loadSlotData(val.format("YYYY-MM-DD"))
        }else{
            formik.setFieldError('date', 'Invalid date format')
        }
    }       
  }

  const handlePractitionerChange = (event) => {
    setPractitionerId(event?.target?.value)
    formik.setFieldValue("practitioner", formik?.values?.practitionerPreference === "no preference" ? "" : event?.target?.value);
    formik.setFieldValue("serviceCategory", ""); 
    formik.setFieldValue("date", "");
    setServiceCategory([]);
    setAvailableSlots([]);
    setCategoriesByDay([]);
  };

  const handlePractitionerPreferenceChange = (e) => {
    setPractitionerId(null); 

    formik.setFieldValue("practitioner", "");
    formik.setFieldValue("serviceCategory", ""); 
    formik.setFieldValue("date", "");
    setServiceCategory([]);
    setAvailableSlots([]);        
    setCategoriesByDay([]);
    formik.setFieldValue("practitionerPreference", e.target.id);
  };

  const removePastSlots = (slots) => {
    let now = new Date().getTime();
    return slots?.filter(slot => new Date(slot.start).getTime() > now);
}

  const sortedSlots = (data) => {
    return data.sort((a, b) => {
      let atime = (moment(a.start).isValid()) ? `${a.start}`:`${moment(formik.values.date)?.format("YYYY-MM-DD")}T${a?.start}:00Z`;
      let btime = (moment(b.start).isValid()) ? `${b.start}`:`${moment(formik.values.date)?.format("YYYY-MM-DD")}T${b?.start}:00Z`;
      let aHr = moment(atime).hour();
      let bHr = moment(btime).hour();
      let aMin = moment(atime).minute();
      let bMin = moment(btime).minute();
      return aHr < bHr || (aHr == bHr && aMin < bMin) ? -1 : 1;
    });
  };

  const findUpcoming = (event) => {
    setSlotUnavailable(false);        
    let targetVal = event?.target?.value;
    formik.setFieldValue("serviceCategory", targetVal);
    setAvailableSlots([])
    formik.setFieldValue("date", "");
  }

  const renderDay = (props) => {
    const { selectedDate, day, dayComponent, ...other} = props;
    const today = moment();
    const isAvailable = availableDays.includes(day.format("YYYY-MM-DD"));
    const isSelected = day.isSame(selectedDate, "day");
    const isToday = day.isSame(today, "day");
    const isPast = day.isBefore(today, "day")

    return (
        <PickersDay {...dayComponent} 
            disabled={isPast || !isAvailable}
            style={isAvailable ? {background: "#accfeb"}: {background: "white" }} />
    );
  }

  useEffect(() => {
    let startDate = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
    startDate = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
    // if (formik?.values?.date) {
    let start = startDate.split("T")?.[0];
    if(formik?.values?.practitionerPreference &&
         ((formik?.values?.practitionerPreference === "select practitioner" && practitionerId)
            || formik?.values?.practitionerPreference === "no preference" )) {
        checkSchedule({actorId: (formik?.values?.practitionerPreference === "no preference" ? user["custom:unique_id"] :  practitionerId), date: startDate, orgId: (formik?.values?.practitionerPreference === "no preference" ? user?.organizations[0]?.id : null)}) 
        .then((res) => { 
                if(!res?.data) {
                    failed(res?.message);
                    setServiceCategory([]);
                    setCategoriesByDay({});
                    return;
                }
                
                let categories = [];
                if (!Array.isArray(res.data)) res.data = [res.data];
                setFetchedSchedules(res.data);
                let tempByDay = {};
                res.data.forEach(schedule => {                    
                    schedule.serviceCategory.forEach(category => {
                        let key = category?.date?.split('T')?.[0];
                        if(moment(key).isSameOrAfter(moment(start)) && 
                            !categories.some(item => item.value === category.id)) {
                            categories.push({...category, value: category?.id});                                
                        }
                        if(moment(key).isSameOrAfter(moment(start))) {
                            if(tempByDay[key]) {
                                if(!tempByDay[key].some(id => id === category.id )) 
                                    tempByDay[key].push(category.id)
                            }
                            else tempByDay[key] = [category.id];   
                        }
                    })
                    setCategoriesByDay(Object.assign(categoriesByDay, tempByDay))                       
                })
                let reservedSlots ={}
                let newData = [];
                res.data.forEach(schedule => 
                    getScheduleSlots(schedule.id, "busy-reserved", userOrgId)
                    .then((resp) => {
                        resp.data?.filter((slot)=> moment(slot?.start).isSameOrAfter(moment(start)))
                        ?.map((slot) => {
                          slot.serviceCategory?.forEach(cat => {
                            let serviceCategoryId = cat.id;
                            if (reservedSlots.hasOwnProperty(serviceCategoryId)) {
                                reservedSlots[serviceCategoryId].push({
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "scheduleId": slot?.scheduleId,
                                    "serviceCategory": [cat],
                                    "actorId": schedule.actorId,
                                    "status": "busy-reserved"
                                });
                            }    
                            else {
                                reservedSlots[serviceCategoryId] = [{
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "scheduleId": slot?.scheduleId,
                                    "serviceCategory": [cat],
                                    "actorId": schedule.actorId,
                                    "status": "busy-reserved"
                                }];
                            }
                          })

                        })
                        if(Array.isArray(reservedSlots))
                            reservedSlots = removePastSlots(reservedSlots)
                        else {
                            Object.keys(reservedSlots).forEach(key => {
                                reservedSlots[key] = removePastSlots(reservedSlots[key])
                            })
                        }
                        Object.keys(reservedSlots).forEach(key => {
                          if(reservedSlots[key].length > 0 
                              && (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code)) {
                              // && !newData.some(item => item.value === `${reservedSlots[key][0]?.serviceCategory?.[0]?.id}-busyReserved`)) {
                              // console.log("RESERVED SLOT KEY", key)
                              // newData.push({
                              //     name: `Reserved for ${reservedSlots[key]?.[0]?.serviceCategory[0]?.name}`,
                              //     value: `${reservedSlots[key][0]?.serviceCategory?.[0]?.id}-busyReserved`,
                              //     status: "busy-reserved"
                              // });
                              if(moment(reservedSlots[key][0]?.start).isSameOrAfter(startDate, "day") && 
                              !categories.some(item => item.value === key)) {
                                  let timeSlot = reservedSlots[key][0]?.serviceCategory?.[0]?.timeSlot;
                                  if(!timeSlot) {
                                      // slot is in a different format, so you need to parse the description to get the timeslot.
                                      let timeSlotString = reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display.split("(")[1].split(")")[0].split(" ");
                                      // this should be an array of number and unit now.
                                      timeSlot = { 
                                          value: parseInt(timeSlotString[0]),
                                          unit: 'minutes'
                                      };
                                  }
                                  let name = `${formik.values.practitioner.length > 0 ? "Reserved for " :"" } ${reservedSlots[key]?.[0]?.serviceCategory[0]?.name || reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display}`;
                                  let value = (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code);
                                  categories.push({
                                      name, 
                                      id: value,
                                      value,
                                      timeSlot,
                                      orgId: reservedSlots[key][0].orgId,
                                      date: reservedSlots[key][0]?.start
                                  })
                              }
                              // ADD TO CATEGORIES BY DAY HERE
                              tempByDay = {};
                              if(reservedSlots[key].length > 0) {
                                  reservedSlots[key].forEach(slot => {
                                      let datekey = moment(slot?.start).format("YYYY-MM-DD");
                                      let startTimestamp  = moment(slot?.start).valueOf();
                                      console.log(moment(startTimestamp).isSameOrAfter(moment(startDate), "day"))
                                      if(moment(startTimestamp).isSameOrAfter(moment(startDate), "day")) {
                                          if(tempByDay[datekey] && !tempByDay[datekey]?.some(id => id === key)) {
                                                  tempByDay[datekey].push(key);
                                          }
                                          else tempByDay[datekey] = [key];
                                      }
                                  })
                              }
                              setCategoriesByDay(merge(categoriesByDay, tempByDay)) 
                          }
                        });
                        setReservedCategories(reservedSlots);
                        setServiceCategory([...categories, ...newData])                            
                    })
                    .catch((res) => {
                        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                        setServiceCategory([]);
                        setCategoriesByDay({});
                    })
                );
            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                setServiceCategory([]);
                setCategoriesByDay({});
            });
    }
  }, [formik?.values?.practitioner, formik?.values?.practitionerPreference]);

  const highLightDates = () => {
    setAvailableDays([]);
    const today = moment();
    const now = moment();
    const toHighlight = [];

    const foundCategory = serviceCategory.find(
      (item) => item.id === formik.values.serviceCategory
    );

    if (!foundCategory || !foundCategory.timeSlot) {
      setAvailableDays([]);
      return;
    }

    const timeSlot = parseInt(foundCategory.timeSlot.value, 10);
    const availabilities = computedServiceCategories?.[formik.values.serviceCategory] || [];

    availabilities.forEach((period) => {
      let periodStart = moment(period.start);
      let periodEnd = moment(period.end);

      // Only consider today or future days
      if (periodStart.isBefore(today, "day")) return;

      // Adjust current period if it’s today
      if (periodStart.isSame(today, "day")) {
        if (periodEnd.isBefore(now)) return;
        if (periodStart.isBefore(now)) periodStart = now.clone();
      }

      const availableMinutes = periodEnd.diff(periodStart, "minutes");
      if (availableMinutes >= timeSlot) {
        const dayKey = periodStart.format("YYYY-MM-DD");
        if (!toHighlight.includes(dayKey)) {
          toHighlight.push(dayKey);
        }
      }
    });

    setAvailableDays(toHighlight);
  };
  
  
  const fetchSchedules = async () => {
    const schedulesWithSlots = await Promise.all(
        fetchedSchedules.map(async (schedule) => {
        const slotsResponse = await getScheduleSlots(schedule.id);
        const slots = slotsResponse.data || [];
        return { ...schedule, slots };
        })
    );

    const result = computeServiceCategoryAvailabilities(schedulesWithSlots);
    setComputedServiceCategories(result);
  };
  
  
  const computeServiceCategoryAvailabilities = (schedules) => {
    const busyStatuses = [
        "busy-meeting", "busy-unavailable", "busy-training", "busy-documentation",
        "busy-meal", "busy-administration", "busy-unscheduled", "busy-break", "busy-other",
    ];

    // Removes a busy period from available blocks
    const subtractTimePeriod = (availabilityPeriods, slotStart, slotEnd) => {
        const updated = [];

        for (const period of availabilityPeriods) {
        if (slotEnd <= period.start || slotStart >= period.end) {
            updated.push(period); // no overlap
        } else {
            if (slotStart > period.start) {
            updated.push({ start: period.start, end: slotStart }); // before busy time
            }
            if (slotEnd < period.end) {
            updated.push({ start: slotEnd, end: period.end }); // after busy time
            }
        }
        }

        return updated;
    };

    // Adds a new reserved time block
    const insertTimePeriod = (availabilityPeriods, slotStart, slotEnd) => {
        return [...availabilityPeriods, { start: slotStart, end: slotEnd }];
    };

    // Merges overlapping or adjacent time blocks
    const mergeTimePeriods = (periods) => {
        if (!periods.length) return [];

        periods.sort((a, b) => a.start - b.start);
        const merged = [periods[0]];

        for (let i = 1; i < periods.length; i++) {
        const last = merged[merged.length - 1];
        const current = periods[i];

        if (current.start <= last.end) {
            last.end = new Date(Math.max(last.end, current.end)); // merge
        } else {
            merged.push(current);
        }
        }

        return merged;
    };

    const serviceCategoryAvailabilities = {};
    const allServiceCategories = {};

    for (const schedule of schedules) {
        const planningStart = new Date(schedule.planningHorizon.start);
        const planningEnd = new Date(schedule.planningHorizon.end);

        // Step 1: Add initial availability per service category
        for (const sc of schedule.serviceCategory || []) {
        const scId = sc.id;
        const scName = sc.name;
        const scDate = new Date(sc.date);

        const y = scDate.getFullYear();
        const m = scDate.getMonth();
        const d = scDate.getDate();

        const dayStart = new Date(y, m, d, planningStart.getHours(), planningStart.getMinutes());
        const dayEnd = new Date(y, m, d, planningEnd.getHours(), planningEnd.getMinutes());

        // Clamp dayStart and dayEnd within planning horizon
        if (dayStart < planningStart && planningStart.toDateString() === dayStart.toDateString()) {
            dayStart.setHours(planningStart.getHours(), planningStart.getMinutes());
        }
        if (dayEnd > planningEnd && planningEnd.toDateString() === dayEnd.toDateString()) {
            dayEnd.setHours(planningEnd.getHours(), planningEnd.getMinutes());
        }

        if (dayStart >= dayEnd) continue;

        if (!allServiceCategories[scId]) {
            allServiceCategories[scId] = { id: scId, name: scName };
        }

        if (!serviceCategoryAvailabilities[scId]) {
            serviceCategoryAvailabilities[scId] = [];
        }

        serviceCategoryAvailabilities[scId].push({ start: dayStart, end: dayEnd });
        }

        // Step 2: Apply slots to subtract or insert busy times
        for (const slot of schedule.slots || []) {
        const slotStart = new Date(slot.start);
        const slotEnd = new Date(slot.end);
        const slotStatus = slot.status;
        const slotServiceCategories = slot.serviceCategory || [];

        const scTypes = slotServiceCategories.map((item) =>
            item?.id
            ? { id: item.id, name: item.name }
            : { id: item?.coding?.[0]?.code, name: item?.coding?.[0]?.display }
        );

        if (slotStatus === "busy-reserved") {
            // Reserved time should be removed from *other* categories
            for (const scId in serviceCategoryAvailabilities) {
            if (!scTypes.find((s) => s.id === scId)) {
                serviceCategoryAvailabilities[scId] = subtractTimePeriod(
                serviceCategoryAvailabilities[scId],
                slotStart,
                slotEnd
                );
            }
            }

            // But added to the reserved category
            for (const sc of scTypes) { 
            allServiceCategories[sc.id] = allServiceCategories[sc.id] || sc;
            serviceCategoryAvailabilities[sc.id] = insertTimePeriod(
                serviceCategoryAvailabilities[sc.id] || [],
                slotStart,
                slotEnd
            );
            }
        } else if (busyStatuses.includes(slotStatus)) {
            // Generic busy time blocks availability for all categories
            for (const scId in serviceCategoryAvailabilities) {
            serviceCategoryAvailabilities[scId] = subtractTimePeriod(
                serviceCategoryAvailabilities[scId],
                slotStart,
                slotEnd
            );
            }
        }
        }
    }

    // Step 3: Merge overlapping time periods per category
    for (const scId in serviceCategoryAvailabilities) {
        serviceCategoryAvailabilities[scId] = mergeTimePeriods(serviceCategoryAvailabilities[scId]);
    }

    return serviceCategoryAvailabilities;
  };

  useEffect(() => {
      if(fetchedSchedules.length > 0 && formik?.values?.practitionerPreference) {
          fetchSchedules()
      }
  }, [fetchedSchedules, formik?.values?.practitionerPreference]);

  return (
    <>
      <Modal
        backdropClassName
        backdrop={"static"}
        show={onShow}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-dialog appointment-custom-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title id="contained-modal-title-vcenter">
            Create Appointment for{" "}
            <span style={{ textTransform: "capitalize" }}>{patientName}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            className="common-form border-fields"
            onSubmit={formik.handleSubmit}
          >
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50vh",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                <Row>
                  <Col>
                    <TextInput
                      keyField={"title"}
                      label={"Reason for visit"}
                      formik={formik}
                      placeholder={"Reason for visit"}
                    />
                  </Col>
                  <Col>
                    {!type ? null : (
                      <TextInput
                        keyField={"patient"}
                        label={"Patient Name"}
                        formik={formik}
                        disabled={true}
                        placeholder={"Patient Name"}
                        style={{ textTransform: "capitalize" }}
                      />
                    )}
                  </Col>
                </Row>
                {type === "patient" ? (
                  <Row>
                    <Col>
                      <Form.Check.Label
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                        }}
                      >
                        {"practitioner preference ?"}
                      </Form.Check.Label>{" "}
                      <span className="requiredField">&#42;</span>
                      <br />
                      {["select practitioner", "no preference"].map((val) => (
                        <Form.Check
                          style={{
                            textTransform: "capitalize",
                            fontSize: "14px",
                            marginRight: "45px",
                          }}
                          inline
                          checked={formik.values.practitionerPreference === val}
                          type={"radio"}
                          label={val}
                          id={val}
                          name="practitioner preference"
                          onChange={handlePractitionerPreferenceChange}
                        />
                      ))}
                      {formik?.touched["practitionerPreference"] &&
                      formik?.errors["practitionerPreference"] ? (
                        <div className="error-text">
                          {formik?.errors["practitionerPreference"]}{" "}
                        </div>
                      ) : null}
                    </Col>
                    {formik?.values?.practitionerPreference ===
                    "select practitioner" ? (
                      <Col>
                        <SelectFiled
                          keyField={"practitioner"}
                          label={"Select Practitioner"}
                          formik={formik}
                          options={sortedObj(practitionerList)}
                          isReadOnly={true}
                          onChange={handlePractitionerChange}
                        />
                      </Col>
                    ) : (
                      <Col></Col>
                    )}
                  </Row>
                ) : null}
                <Row className="mt-3">
                  <Col>
                    <SelectFiled keyField={"serviceCategory"} label={"Appointment Type"} formik={formik} options={sortedObj(serviceCategory)} disabled={!formik.values.practitionerPreference} onChange={findUpcoming} />
                  </Col>
                  <Col>
                    <DateSelectorWithoutFormik disabled={!formik?.values?.serviceCategory} formik={formik} keyField={'date'} label="Date" value={moment(formik?.values?.date)} handleChange={(value) => { handleDateSelection(value)}} minDate={moment()} defaultValue={moment()} onMonthChange={highLightDates} onOpen={highLightDates} renderDay={(day, selectedDate, dayComponent) => renderDay({day, selectedDate, dayComponent})} />
                  </Col>
                </Row>
                {availableSlots?.length > 0 ? (
                  <>
                    <Row>
                      <Col>Select Slot</Col>
                    </Row>
                    <Row
                      style={{
                        rowGap: "0.5rem",
                        marginBottom: "1.5rem",
                        marginTop: "0.5rem",
                      }}
                    >
                      {availableSlots?.map((slot, index) => {
                        let time;
                        let localTime;
                        if (slot?.status === "busy-reserved") {
                          localTime = moment(slot?.start).format("HH:mm");
                        } else {
                          localTime = moment(slot?.start).format("HH:mm");
                        }

                        return (
                          <Col
                            style={{
                              background:
                                selectedSlot === slot?.start
                                  ? "#6c757d38"
                                  : "#ffff",
                              width: "14.666667%",
                            }}
                            sm={2}
                            className="slotStyle"
                            key={index}
                            onClick={() => {
                              formik?.setFieldValue("availableSlot", slot);
                              setSelectedSlot(slot?.start);
                            }}
                          >
                            {localTime}
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                ) : (
                  <div
                    className="error-text"
                    style={{
                      marginBottom: "1.5rem",
                      display: slotUnavailable ? "block" : "none",
                    }}
                  >
                    No Available Slots
                  </div>
                )}

                {slotsLoading ? (
                  <>
                    <Row>
                      <Col>Select Slot</Col>
                    </Row>
                    <Skeleton height={50} />
                  </>
                ) : null}
                <Row>
                  <Col>
                    <Form.Check.Label
                      style={{ textTransform: "capitalize", fontSize: "14px" }}
                    >
                      {"preferred channel ?"}
                    </Form.Check.Label>{" "}
                    <span className="requiredField">&#42;</span>
                    <br />
                    {["phone", "video/chat"].map((val) => (
                      <Form.Check
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                          marginRight: "65px",
                        }}
                        inline
                        checked={formik.values.preferredChannel === val}
                        type={"radio"}
                        label={val}
                        id={val}
                        name="preferred channel"
                        onChange={(e) =>
                          formik.setFieldValue("preferredChannel", e.target.id)
                        }
                      />
                    ))}
                    {formik?.touched["preferredChannel"] &&
                    formik?.errors["preferredChannel"] ? (
                      <div className="error-text">
                        {formik?.errors["preferredChannel"]}{" "}
                      </div>
                    ) : null}
                  </Col>
                  {type !== "patient" ? null : (
                    <>
                      <Col>
                        <Row>
                          <Col>
                            <TextInput
                              keyField={"returnTelephoneNumber"}
                              type="phone"
                              label={"Return Telephone Number"}
                              formik={formik}
                              disabled={false}
                              placeholder={"Return Telephone Number"}
                              required={true}
                            />
                          </Col>
                          <Col>
                            <TextInput
                              style={{ marginTop: "1.7rem", width: "5.0rem" }}
                              keyField={"returnTelephoneNumberExt"}
                              label={"Ext."}
                              formik={formik}
                              disabled={false}
                              placeholder={"Ext."}
                              required={false}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </>
                  )}
                </Row>

                <Row></Row>
                <Row></Row>
              </>
            )}
            <div className="btn-wrap">
              <Button
                onClick={() => {
                  onHide();
                }}
                variant="secondary"
                title="Cancel"
              >
                Cancel
              </Button>
              <Button type="submit" isLoading={btnLoading}>
                Create
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ScheduleAppointmentWR;
